import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <h4 className="text-lg font-heading font-semibold text-background-50 mb-4">禁漫天堂</h4>
            <p className="text-sm text-background-400 leading-relaxed">
              深受用户喜爱的成人漫画平台，提供海量优质漫画资源和流畅阅读体验。官方网站为您提供最新入口、使用教程和常见问题解答。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="flex flex-col gap-2">
              <li><Link to="/" className="text-sm text-background-400 hover:text-background-100 transition-colors">首页</Link></li>
              <li><Link to="/category/hot" className="text-sm text-background-400 hover:text-background-100 transition-colors">热门推荐</Link></li>
              <li><Link to="/category/new" className="text-sm text-background-400 hover:text-background-100 transition-colors">最新上架</Link></li>
              <li><Link to="/category/japanese" className="text-sm text-background-400 hover:text-background-100 transition-colors">日漫专区</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">更多分类</h4>
            <ul className="flex flex-col gap-2">
              <li><Link to="/category/korean" className="text-sm text-background-400 hover:text-background-100 transition-colors">韩漫专区</Link></li>
              <li><Link to="/category/chinese" className="text-sm text-background-400 hover:text-background-100 transition-colors">国漫专区</Link></li>
              <li><Link to="/category/3d" className="text-sm text-background-400 hover:text-background-100 transition-colors">3D漫画</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">帮助中心</h4>
            <ul className="flex flex-col gap-2">
              <li><Link to="/article/jmtthub-register-login-tutorial" className="text-sm text-background-400 hover:text-background-100 transition-colors">注册教程</Link></li>
              <li><Link to="/article/jmtthub-vip-membership-guide" className="text-sm text-background-400 hover:text-background-100 transition-colors">VIP指南</Link></li>
              <li><Link to="/article/jmtthub-app-download-install" className="text-sm text-background-400 hover:text-background-100 transition-colors">APP下载</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors">联系我们</Link></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-700/40">
        <div className="w-full px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {currentYear} 禁漫天堂 版权所有 | 本站仅为信息导航与使用指南网站
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <span>服务条款</span>
            <span>隐私政策</span>
            <span>免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}